/* raw layout hash: _banquet-event-kits-batch-reconciliation-layout:88a649bfc92d78334f3a5ee9194031d9aace677d6fb60eb3b55dd5b333661591 */
import React from "react";
import AppShell from "./AppShell.jsx";

// Layout "_banquet-event-kits-batch-reconciliation-layout" (RawHTMLDesign/layouts/_banquet-event-kits-batch-reconciliation-layout.html)
export default function BanquetEventKitsBatchReconciliationLayout({ children }) {
  return <AppShell menuKey="set5">{children}</AppShell>;
}
